module.exports = __webpack_public_path__ + "img/app_05.34f4b264.jpg";